import { useMemo } from 'react';
import { getFormattedMonth } from '../utils';

export default function useFormattedMonth(month: Date, locale: string) {
  return useMemo(() => getFormattedMonth(month, locale), [month, locale]);
}
